import React from 'react';
import { WeekChallengeBanner } from './week-challenge-banner';
import { WeekChallengeChallenges } from './week-challenge-challenges';
import { WeekChallengeRankingByRegion } from './week-challenge-ranking-by-region';
import { WeekChallengeRankingByParticipant } from './week-challenge-ranking-by-participant';
import { useQuery } from 'jsonapi-react';
import { WeeklyChallengeProvider } from 'src/app/providers/WeeklyChallenge';
import WeekChallengeAdmin from 'src/app/screens/Admin/WeekChallenge';
import { useCheckIncludeProfiles } from '@/app/hooks/useAuthorityLevel';
import { useNavigate, useLocation } from 'react-router-dom';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function WeekChallenge(props) {
  return (
    <WeeklyChallengeProvider>
      <WeekChallengeContent {...props} />
    </WeeklyChallengeProvider>
  );
}

function WeekChallengeContent(props) {
  const { selectedTab } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const uri = location.pathname;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });

  if (isAdmin)
    return (
      <WeekChallengeAdmin
        selectedTab={selectedTab}
        uri={uri}
      />
    );

  const { data: challenges, isLoading } = useQuery('/challenges');

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: uri,
        name: 'Desafio da Semana',
        isActive: true
      }
    ]
  };

  const BASE_ROUTE = '/desafio-da-semana';

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <Tabs defaultValue={selectedTab || 'desafios'}>
        <TabsList className="mb-8">
          <TabsTrigger
            value="desafios"
            onClick={() => navigate(`${BASE_ROUTE}/desafios`)}
          >
            Desafio
          </TabsTrigger>
          <TabsTrigger
            value="ranking-por-regiao"
            onClick={() => navigate(`${BASE_ROUTE}/ranking-por-regiao`)}
          >
            Ranking por região
          </TabsTrigger>
          <TabsTrigger
            value="ranking-por-participante"
            onClick={() => navigate(`${BASE_ROUTE}/ranking-por-participante`)}
          >
            Ranking por participante
          </TabsTrigger>
        </TabsList>

        <WeekChallengeBanner
          challenges={challenges}
          isLoading={isLoading}
        />

        <TabsContent value="desafios">
          <WeekChallengeChallenges
            challenges={challenges}
            isLoading={isLoading}
          />
        </TabsContent>
        <TabsContent value="ranking-por-regiao">
          <WeekChallengeRankingByRegion />
        </TabsContent>
        <TabsContent value="ranking-por-participante">
          <WeekChallengeRankingByParticipant />
        </TabsContent>
      </Tabs>
    </DashboardContent>
  );
}
